import React from 'react';
import styled from 'styled-components';
import Media from 'react-media';
import { themes } from 'kb-shared';

import { Link, OutlineButton } from 'screens/MyJourney/substeps/styled-components';
import { ReactComponent as VideoSvg } from 'assets/icons/video.svg';

interface ProtocolDrug {
  name: string;
  url: string;
}

interface ProtocolDrugsList {
  [key: string]: ProtocolDrug;
}

const MEDICATIONS: ProtocolDrugsList = Object.freeze({
  Cetrotide: {
    name: 'Cetrotide',
    url: 'http://freedommedteach.com/eng/videos.html?play=cetrotide'
  },
  Follistim: {
    name: 'Follistim',
    url: 'https://portal.kindbody.com/medication-instruction?med_index=0&medication_name=Follistim'
  },
  Ganirelix: {
    name: 'Ganirelix',
    url: 'https://portal.kindbody.com/medication-instruction?med_index=1&medication_name=Ganirelix'
  },
  'Gonal F': {
    name: 'Gonal F',
    url: 'https://portal.kindbody.com/medication-instruction?med_index=2&medication_name=Gonal-f'
  },
  'hCG Trigger IM': {
    name: 'hCG Trigger IM',
    url: 'http://freedommedteach.com/eng/videos.html?play=novarel-hcg_draw_up%2Cgeneral_im'
  },
  'hCG Trigger SQ': {
    name: 'hCG Trigger SQ',
    url: 'http://freedommedteach.com/eng/videos.html?play=general_sq'
  },
  'Lupron Down Regulation': {
    name: 'Lupron Down Regulation',
    url: 'http://freedommedteach.com/eng/videos.html?play=leuprolide_acetate'
  },
  'Lupron Trigger': {
    name: 'Lupron Trigger',
    url: 'http://freedommedteach.com/eng/videos.html?play=leuprolide_trigger'
  },
  Menopur: {
    name: 'Menopur',
    url: 'https://portal.kindbody.com/medication-instruction?med_index=3&medication_name=Menopur'
  },
  'Microdose Lupron': {
    name: 'Microdose Lupron',
    url: 'http://freedommedteach.com/eng/videos.html?play=leuprolide_acetate'
  },
  'Microflare Lupron': {
    name: 'Microflare Lupron',
    url: 'http://freedommedteach.com/eng/videos.html?play=leuprolide_acetate'
  },
  'Ovidrel Trigger': {
    name: 'Ovidrel',
    url: 'http://www.freedommedteach.com/eng/videos.html?play=ovidrel'
  },
  'Progesterone in Oil': {
    name: 'Progesterone in Oil',
    url: 'http://freedommedteach.com/eng/videos.html?play=progesterone_in_oil'
  }
});

interface DrugNameProps {
  drugName: string;
}

const InjectionVideoButton = ({ drugName }: DrugNameProps) => {
  const medication = MEDICATIONS[drugName];
  if (!medication) {
    return null; // not all drugs have videos
  }

  return (
    <SmallButton key={medication.name}>
      <Link href={medication.url} target="_blank">
        <VideoSvg width={21} />
        <Media query={{ minWidth: themes.breakpoints.raw.largePhonePortrait }}>
          {matches => (matches ? <>&nbsp; Video</> : null)}
        </Media>
      </Link>
    </SmallButton>
  );
};

export default InjectionVideoButton;

const SmallButton = styled(OutlineButton)`
  width: 100%;
  line-height: 0;
  padding: 5px 0;
  background-color: transparent;
  border-color: transparent;

  & > a {
    justify-content: center;
  }

  @media screen and (min-width: ${({ theme }) => theme.largePhonePortrait}) {
    & > a {
      justify-content: flex-start;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.tabletPortrait}) {
    max-width: none;
    padding: 5px 10px;
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.night};
  }

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    font-size: inherit;
  }

  :not(:last-of-type) {
    margin-right: 15px;
  }
`;
